<template>
  <div class="cargolist">
    <m-title :titlelist="listitem"></m-title>
    <div class="southcargonn">
      <div class="bigbox">
        <div class="southcargo_top">
          <columnper :itemper="itemper / 1000" :amount="amount"></columnper>
          <div class="southcargo_top_content">
            <el-row>
              <el-col :span="6">
                <span class="rowtitle">计划单号:</span>
                <span class="rowmsg">{{ iteminfo.pno }}</span>
              </el-col>
              <el-col :span="6">
                <span class="rowtitle">货物名称:</span>
                <span class="rowmsg">{{ iteminfo.goodsname }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <span class="rowtitle">开始作业日期:</span>
                <span class="rowmsg">{{
                  mydateFormat(iteminfo.startworkdate, "时分秒")
                }}</span>
              </el-col>
              <el-col :span="6">
                <span class="rowtitle">计划来源:</span>
                <span class="rowmsg">{{ changdi[iteminfo.stname] }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <span class="rowtitle">结束作业日期:</span>
                <span class="rowmsg">{{
                  mydateFormat(iteminfo.endworkdate, "时分秒")
                }}</span>
              </el-col>
              <el-col :span="6">
                <span class="rowtitle">船名:</span>
                <span class="rowmsg">{{ iteminfo.shipname }}</span>
                <!-- <span class="rowtitle">货位:</span>
                  <span class="rowmsg">{{ iteminfo.hwstr }}</span> -->
                <!-- <span class="rowtitle">流向:</span>
                  <span class="rowmsg">{{ iteminfo.customername }}</span> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <span class="rowtitle">货主名称:</span>
                <span class="rowmsg">{{ iteminfo.customname }}</span>
              </el-col>
              <el-col :span="6">
                <span class="rowtitle">计划吨数:</span>
                <span class="rowmsg">{{ iteminfo.plantons }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <span class="rowtitle">代理名称:</span>
                <span class="rowmsg">{{ iteminfo.agentname }}</span>
              </el-col>
              <el-col :span="6">
                <span class="rowtitle">完成吨数:</span>
                <span class="rowmsg">{{ iteminfo.sumSullte / 1000 }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <span class="rowtitle">发货地:</span>
                <span class="rowmsg">{{ iteminfo.source }}</span>
              </el-col>
              <el-col :span="6">
                <span class="rowtitle">发往地:</span>
                <span class="rowmsg">{{ iteminfo.destination }}</span>
                <!-- <span class="rowtitle">已派车:</span>
                  <span class="rowmsg">{{ iteminfo.dispatchtruckcount }}</span> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <!-- <span class="rowtitle">已派车队:</span>
                  <span class="rowmsg">{{ iteminfo.customername }}</span> -->
              </el-col>
              <el-col :span="6">
                <!-- <span class="rowtitle">已审核:</span>
                  <span class="rowmsg">{{ iteminfo.checkedtruckcount }}</span> -->
                <!-- <span class="rowtitle">已派车:</span>
                  <span class="rowmsg">{{ iteminfo.carTotalCount }}</span> -->
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="southcargo_bot">
          <div class="southcargo_bot_title">
            <span class="bot_title_l">已派车辆详情</span>
            <!-- <input type="text" style="position:absolute;left: 150px; width: 150px;height: 30px;" placeholder="搜索车牌号" > -->
            <el-input
              type="text"
              class="inp"
              v-model="selectitem.plate"
              placeholder="请输入车牌号"
              clearable
              @clear="getarrlist"
            />
            <button class="exportlist" style="right: 200px" @click="searchlist">
              查询
            </button>
            <button
              class="exportlist"
              style="right: 100px; color: #17b6a1; background: #f3f4f5"
              @click="returnpage"
            >
              返回
            </button>
            <!--<button class="exportlist" @click="exportlist">打印列表</button>-->
          </div>
          <div class="tablebox">
            <el-table
              :data="arrlist.list"
              style="width: 100%; height: 90%"
              height="90%"
            >
              <el-table-column
                prop="fleetname"
                label="车队名称"
                show-overflow-tooltip
                :render-header="renderHeader"
              >
              </el-table-column>
              <el-table-column
                prop="plate"
                label="车牌号"
                show-overflow-tooltip
                :render-header="renderHeader"
              >
              </el-table-column>
              <el-table-column
                label="派车时间"
                show-overflow-tooltip
                :render-header="renderHeader"
              >
                <template v-slot="res">
                  {{ mydateFormat(res.row.gmtCreate, "时分秒") }}
                </template>
              </el-table-column>
              <!-- <el-table-column prop="drivername" show-overflow-tooltip :render-header="renderHeader" label="司机姓名">
                </el-table-column> -->
              <!-- <el-table-column prop="telephone" show-overflow-tooltip :render-header="renderHeader" label="司机电话">
                </el-table-column> -->
              <!-- <el-table-column label="磅房确认时间" show-overflow-tooltip :render-header="renderHeader">
                  <template v-slot="res">
                    {{ mydateFormat(res.row.checkedtime, "时分秒") }}
                  </template>
                </el-table-column> -->
              <el-table-column
                prop="status"
                show-overflow-tooltip
                :render-header="renderHeader"
                label="派单状态"
              >
                <template slot-scope="scope">
                  <template v-for="item in statusList">
                    <div v-if="scope.row.status == item.value">
                      {{ item.text }}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column
                label="完成时间"
                show-overflow-tooltip
                :render-header="renderHeader"
              >
                <template v-slot="res">
                  {{
                    res.row.status == 60
                      ? mydateFormat(res.row.outstoredate, "时分秒")
                      : ""
                  }}
                </template>
              </el-table-column>
              <el-table-column
                prop="guobangcount"
                label="运输车次"
                show-overflow-tooltip
                :render-header="renderHeader"
              ></el-table-column>
              <el-table-column
                prop="suttle"
                label="运输净重(吨)"
                show-overflow-tooltip
                :render-header="renderHeader"
              >
                <template v-slot="res">
                  {{ res.row.suttle / 1000 }}
                </template>
              </el-table-column>
              <!-- <el-table-column label="审核时间" show-overflow-tooltip :render-header="renderHeader">
                  <template v-slot="res">
                    {{ mydateFormat(res.row.checkedtime, "时分秒") }}
                  </template>
                </el-table-column>
                <el-table-column label="预约时段" show-overflow-tooltip :render-header="renderHeader">
                  <template v-slot="res">
                    {{ mydateFormat(res.row.ordertime, "时分秒") }}
                  </template>
                </el-table-column> -->
              <!-- <el-table-column prop="gotime" show-overflow-tooltip :render-header="renderHeader" label="进场时间">
                  <template v-slot="res">
                    {{ mydateFormat(res.row.instoredate, "时分秒") }}
                  </template>
                </el-table-column> -->
              <el-table-column
                prop="backtime"
                show-overflow-tooltip
                :render-header="renderHeader"
                label="回皮时间"
                v-if="plantype !== '港内集疏'"
              >
                <template v-slot="res">
                  {{ mydateFormat(res.row.pwitemdate, "时分秒") }}
                </template>
              </el-table-column>
              <el-table-column
                prop="tare"
                show-overflow-tooltip
                :render-header="renderHeader"
                label="回皮吨数"
                v-if="plantype !== '港内集疏'"
              >
                <template v-slot="res">
                  {{ res.row.tare / 1000 }}
                </template>
              </el-table-column>
              <!-- <el-table-column label="装车时间" show-overflow-tooltip :render-header="renderHeader">
                  <template v-slot="res">
                    {{ mydateFormat(res.row.loaddate, "时分秒") }}
                  </template>
                </el-table-column> -->
              <el-table-column
                show-overflow-tooltip
                :render-header="renderHeader"
                label="装车吨数"
                v-if="plantype !== '港内集疏'"
              >
                <template v-slot="res">
                  {{ res.row.suttle / 1000 }}
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                :render-header="renderHeader"
                label="过重时间"
                v-if="plantype !== '港内集疏'"
              >
                <template v-slot="res">
                  {{ mydateFormat(res.row.mwitemdate, "时分秒") }}
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                :render-header="renderHeader"
                label="过重吨数"
                v-if="plantype !== '港内集疏'"
              >
                <template v-slot="res">
                  {{ res.row.roughWeight / 1000 }}
                </template>
              </el-table-column>
              <!-- <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="livetime" label="出场时间">
                  <template v-slot="res">
                    {{ mydateFormat(res.row.outstoredate, "时分秒") }}
                  </template>
                </el-table-column> -->
              <el-table-column
                show-overflow-tooltip
                :render-header="renderHeader"
                label="操作"
              >
                <template v-slot="res">
                  <el-tooltip content="查看装卸货凭证图片" effect="light">
                    <span
                      class="iconfont icon-tongjifenxi"
                      @click="showTimeline(res.row)"
                    ></span>
                  </el-tooltip>
                  <el-tooltip content="查看磅单" effect="light">
                    <span
                      style="margin-left: 10px"
                      class="iconfont icon-xiugai"
                      @click="editres(res.row)"
                    ></span>
                  </el-tooltip>
                  <el-tooltip content="车辆轨迹" effect="light">
                    <span
                      style="margin-left: 10px"
                      @click="getmapinfo(res.row)"
                      class="iconfont icon-chakan"
                    ></span>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <div class="paging">
              <el-pagination
                :page-size="selectitem.limit"
                layout="total,prev, pager,next, jumper"
                :total="arrlist.totalCount"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="plate" :visible.sync="dialogTable">
      <el-table :data="WeightList.list" height="300">
        <el-table-column prop="suttle" label="装车吨数(吨)" width="120">
          <template v-slot="scoped">
            <div>
              {{ (scoped.row.suttle / 1000).toFixed(2) || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="roughWeight" label="过重吨数(吨)" width="120">
          <template v-slot="scoped">
            <div>
              {{ (scoped.row.roughWeight / 1000).toFixed(2) || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="tare" label="回皮吨数(吨)" width="120">
          <template v-slot="scoped">
            <div>
              {{ (scoped.row.tare / 1000).toFixed(2) || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="overweightTime"
          label="过重时间"
          show-overflow-tooltip
        >
          <template v-slot="scoped">
            <div>
              {{ mydateFormat(scoped.row.overweightTime, "时分秒") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="skinTime" label="回皮时间" show-overflow-tooltip>
          <template v-slot="scoped">
            <div>
              {{ mydateFormat(scoped.row.skinTime, "时分秒") }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total,prev, pager,next, jumper"
        :page-size="limit"
        :total="WeightList.totalCount"
        :current-page.sync="page"
        @current-change="dialogCurrentChange"
      ></el-pagination>
    </el-dialog>

    <table
      class="tableprint"
      ref="tablelist"
      style="width: 99%; margin: 10px 0.5%; border-collapse: collapse"
    >
      <tr>
        <th style="border: 1px solid">代理名称</th>
        <th style="border: 1px solid">车牌号</th>
        <th style="border: 1px solid">毛重</th>
        <th style="border: 1px solid">皮重</th>
        <th style="border: 1px solid">净重</th>
        <th style="border: 1px solid">过重时间</th>
      </tr>
      <template v-for="item in tabledata">
        <tr :key="item.id">
          <td style="border: 1px solid; text-align: center">
            {{ item.fleetname }}
          </td>
          <td style="border: 1px solid; text-align: center">
            {{ item.plate }}
          </td>
          <td style="border: 1px solid; text-align: center">
            {{ item.roughWeight }}
          </td>
          <td style="border: 1px solid; text-align: center">{{ item.tare }}</td>
          <td style="border: 1px solid; text-align: center">
            {{ item.suttle }}
          </td>
          <td style="border: 1px solid; text-align: center">
            {{ mydateFormat(item.mwitemdate, "时分秒") }}
          </td>
        </tr>
      </template>
    </table>
    <el-drawer title="装卸货凭证图片" :visible.sync="drawer">
      <el-timeline v-if="activities.length > 0">
        <el-timeline-item
          v-for="(activity, index) in activities"
          :type="activity.type"
          :key="index"
          :timestamp="activity.timestamp"
        >
          <div :class="activity.type == 'primary' ? 'bold-name' : ''">
            {{ activity.name }}
          </div>
          <div v-if="activity.weight">{{ activity.weight }}吨</div>
          <el-image
            :src="activity.imgUrl"
            style="width: 100px"
            v-if="activity.imgUrl"
            :preview-src-list="[activity.imgUrl]"
          ></el-image>
        </el-timeline-item>
      </el-timeline>
      <el-empty v-else></el-empty>
    </el-drawer>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import mChebox from "@/components/mChebox.vue";
import columnper from "@/components/columnper";
import { mixins } from "@/mixin/index.js";
import changdi from "@/plugins/changdi.json";
import dayjs from "dayjs";
export default {
  name: "planlistParticulars",
  data() {
    return {
      listitem: [
        { name: "计划管理" },
        { name: "计划列表", path: "/plan/planlist" },
        { name: "详情" },
      ],
      selectitem: {
        page: 1, //当前页码
        limit: 20, //每页显示条数
        pno: "",
        sidx: "", //排序字段
        order: "", //排序方式
        plate: "",
      },
      tabledata: [],
      iteminfo: {},
      arrlist: {},
      itemper: 0,
      amount: 1,
      timeout: null,
      plantype: "",
      dialogTable: false,
      WeightList: {},
      plate: "",
      page: 1, //当前页码
      limit: 20, //每页显示条数
      truckId: "",
      changdi: changdi,
      drawer: false,
      dispatchtruckId: "",
      activities: [],
    };
  },
  components: {
    mTitle,
    columnper,
    mChebox,
  },
  mixins: [mixins],
  created() {
    let obj = JSON.parse(window.sessionStorage.getItem("infoid"));
    this.sumSullte = obj.sumSullte ? obj.sumSullte : 0;
    this.selectitem.pno = obj.pno;
    this.getItemInfo(obj.id);
    this.getarrlist();
    this.plantype = this.$route.query.plantype;
  },
  methods: {
    //车辆轨迹
    getmapinfo(row) {
      console.log(row);
      let startTime = this.mydateFormat(row.gmtCreate, "时分秒");

      let endTime =
        row.status == 60 ? this.mydateFormat(row.outstoredate, "时分秒") : "";
      this.$router.push({
        path: "/member/cheliangguiji",
        query: {
          plate: row.plate,
          gmtCreate: startTime,
          gmtModified: endTime,
          pno: row.pno,
        },
      });
    },

    // 查看港内详情
    editres(row) {
      this.plate = row.plate;
      this.truckId = row.id;
      this.getdialogtabel(this.truckId);
      this.dialogTable = true;
    },
    //切换页
    dialogCurrentChange(val) {
      this.page = val;
      this.getdialogtabel(this.truckId);
    },
    //获取详情列表
    async getdialogtabel(truckId) {
      const { data } = await this.$http(
        "api1",
        "api/driver/WeightList/list",
        "get",
        { truckId, page: this.page, limit: this.limit }
      );
      if (!data) return this.$message.error("获取数据失败");
      console.log(data);
      this.WeightList = data.data;
    },
    async getItemInfo(id) {
      const { data } = await this.$http(
        "api1",
        `/fleet/plan/pcPlanByPno`,
        "get",
        {
          id,
        }
      );
      if (!data) return this.$message.error("获取数据失败");
      this.iteminfo = data.data;
      this.itemper = data.data.sumSullte ? data.data.sumSullte : 0;
      this.amount = data.data.plantons;
    },
    searchlist() {
      this.selectitem.page = 1;
      this.getarrlist();
    },
    async getarrlist() {
      const { data } = await this.$http(
        "api1",
        "/driver/dispatchtruck/planDispatchTruckList",
        "get",
        this.selectitem
      );
      if (!data) return this.$message.error("获取数据失败");
      this.arrlist = data.data;
    },
    exportlist() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async (_) => {
        const { data } = await this.$http(
          "api1",
          "/driver/dispatchtruck/exportPlanDispatchTruckList",
          "get",
          { pno: this.selectitem.pno }
        );
        if (!data) return;
        this.tabledata = data.data;
        this.$nextTick((_) => {
          this.$print(this.$refs.tablelist);
        });
      }, 300);
    },
    returnpage() {
      this.$router.go(-1);
    },
    handleCurrentChange(index) {
      if (this.arrlist.totalCount < this.selectitem.limit) return;
      this.selectitem.page = index;
      this.getarrlist();
    },
    showTimeline(row) {
      this.dispatchtruckId = row.id;
      this.initTimeLine();
      this.drawer = true;
    },

    getFormattedDate(date, format) {
      if (!date) {
        return null;
      }
      return dayjs(date).format(format);
    },
    async initTimeLine() {
      this.activities = [];
      const res = await this.$http(
        "api1",
        "/api/driverDispatchVoucher/listDispatchInfo",
        "get",
        { trunkId: this.dispatchtruckId }
      );
      res.data.data.forEach((item, index) => {
        this.activities.push({
          name: "第" + (index + 1) + "次运输",
          type: "primary",
        });
        if (item.loadVoucher) {
          this.activities.push({
            name: "装货凭证",
            imgUrl: item.loadVoucher.voucherImg,
            weight: item.loadVoucher.voucherWeight,
            type: "info",
            timestamp: this.getFormattedDate(
              item.loadVoucher.createTime,
              "YYYY-MM-DD HH:mm:ss"
            ),
          });
          this.activities.push({
            name: "车头照片",
            type: "info",
            imgUrl: item.loadVoucher.voucherCarImg,
            timestamp: this.getFormattedDate(
              item.loadVoucher.createTime,
              "YYYY-MM-DD HH:mm:ss"
            ),
          });
          this.activities.push({
            name: "车尾照片",
            type: "info",
            imgUrl: item.loadVoucher.voucherHangCarImg,
            timestamp: this.getFormattedDate(
              item.loadVoucher.createTime,
              "YYYY-MM-DD HH:mm:ss"
            ),
          });
        }
        if (item.unloadVoucher) {
          this.activities.push({
            name: "卸货凭证",
            type: "info",
            weight: item.unloadVoucher.voucherWeight,
            imgUrl: item.unloadVoucher.voucherImg,
            timestamp: this.getFormattedDate(
              item.unloadVoucher.createTime,
              "YYYY-MM-DD HH:mm:ss"
            ),
          });
          this.activities.push({
            name: "车头照片",
            type: "info",
            imgUrl: item.unloadVoucher.voucherCarImg,
            timestamp: this.getFormattedDate(
              item.unloadVoucher.tareVoucherTime,
              "YYYY-MM-DD HH:mm:ss"
            ),
          });
          this.activities.push({
            name: "车尾照片",
            type: "info",
            imgUrl: item.unloadVoucher.voucherHangCarImg,
            timestamp: this.getFormattedDate(
              item.unloadVoucher.createTime,
              "YYYY-MM-DD HH:mm:ss"
            ),
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.cargolist {
  position: relative;
  height: 100%;
  .southcargonn {
    position: absolute;
    top: 50px;
    bottom: 0;
    width: 100%;
    background: #fff;
    .bigbox {
      position: relative;
      box-sizing: border-box;
      height: 100%;
      .southcargo_top {
        position: relative;
        box-sizing: border-box;
        height: 45%;
        border-radius: 2px;
        background: #ffffff;
        padding: 10px;
        overflow: auto;
        .southcargo_top_content {
          position: absolute;
          top: 60px;
          left: 10px;
          right: 10px;
          bottom: 10px;
          font-size: 80%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .el-row {
            padding-left: 2%;
            .rowtitle {
              // font-size: 80%;
              font-weight: bold;
              color: #333333;
            }
            .rowmsg {
              margin-left: 10px;
              // font-size: 80%;
              color: #666666;
            }
          }
        }
      }
      .southcargo_bot {
        position: absolute;
        box-sizing: border-box;
        top: 46%;
        bottom: 0;
        width: 100%;
        overflow: auto;
        overflow: auto;
        background: #ffffff;
        .southcargo_bot_title {
          position: relative;
          box-sizing: border-box;
          //font-size: 80%;
          height: 45px;
          .bot_title_l {
            position: absolute;
            left: 10px;
            top: 50%;
            font-size: 100%;
            transform: translateY(-50%);
            font-weight: bold;
            color: #333333;
          }
          .inp {
            position: absolute;
            left: 130px;
            top: 50%;
            font-size: 80%;
            transform: translateY(-50%);
            width: 160px;
            height: 30px;
            border: none;
            outline: none;
            box-sizing: border-box;
          }
          .exportlist {
            position: absolute;
            height: 30px;
            width: 88px;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            background: #17b6a1;
            border: none;
            border-radius: 5px;
            color: #fff;
            font-size: 80%;
          }
        }
        .tablebox {
          position: absolute;
          top: 45px;
          bottom: 0;
          width: 100%;
          overflow: hidden;
          .paging {
            position: absolute;
            width: 100%;
            bottom: 0;
            height: 30px;
            text-align: center;
          }
        }
      }
    }
  }
  .tableprint {
    display: none;
  }
  .bold-name {
    font-size: 18px;
    font-weight: bold;
  }
}
</style>
